import {
    GET_INVEST_ACCOUNT_REQUEST,
    INVEST_ACCOUNT_CREATE_REQUEST,
    INVEST_ACCOUNT_PATCH_REQUEST,
    INVEST_ACCOUNT_POST_REQUEST,
    INVEST_ACCOUNT_DOCUMENT_UPLOAD_REQUEST,
    PLAID_INTEGRATION_REQUEST,
    GET_PLAID_ACCOUNTS_REQUEST,
    PLAID_FUND_TRANSFER_REQUEST,
    RECURRING_DEPOSIT_REQUEST,
    GET_GOOGLE_CONTACTS_REQUEST,
    REFER_FRIEND_REQUEST,
    SET_BANK_ACCOUNT,
} from '../reducers/AccountReducer';
import { RESET_FLAGS } from "../reducers/AuthReducer";

export const getInvestAccount = payload => ({
    type: GET_INVEST_ACCOUNT_REQUEST,
    payload,
});

export const createInvestAccount = (payload, callback) => ({
    type: INVEST_ACCOUNT_CREATE_REQUEST,
    payload,
    callback,
});

export const patchInvestAccount = (payload, callback) => ({
    type: INVEST_ACCOUNT_PATCH_REQUEST,
    payload,
    callback,
});

export const postInvestAccount = (payload, callback) => ({
    type: INVEST_ACCOUNT_POST_REQUEST,
    payload,
    callback,
});

export const uploadDocumentForInvestAccount = (payload, callback) => ({
    type: INVEST_ACCOUNT_DOCUMENT_UPLOAD_REQUEST,
    payload,
    callback,
});

export const integratePlaid = (payload, callback) => ({
    type: PLAID_INTEGRATION_REQUEST,
    payload,
    callback,
});

export const getPlaidAccounts = (payload, callback) => ({
    type: GET_PLAID_ACCOUNTS_REQUEST,
    payload,
    callback,
});

export const plaidFundTransfer = payload => ({
    type: PLAID_FUND_TRANSFER_REQUEST,
    payload,
});

export const recurringDeposit = payload => ({
    type: RECURRING_DEPOSIT_REQUEST,
    payload,
});

export const getGoogleContacts = payload => ({
    type: GET_GOOGLE_CONTACTS_REQUEST,
    payload,
});

export const referFriend = payload => ({
    type: REFER_FRIEND_REQUEST,
    payload,
});

export const setBankAccount = payload => ({
    type: SET_BANK_ACCOUNT,
    payload,
});

export const resetFlags = () => ({
    type: RESET_FLAGS
});
